import { render } from "./EmailInput.vue?vue&type=template&id=76a07415&scoped=true&ts=true"
import script from "./EmailInput.vue?vue&type=script&lang=ts"
export * from "./EmailInput.vue?vue&type=script&lang=ts"

import "./EmailInput.vue?vue&type=style&index=0&id=76a07415&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a07415"],['__file',"src/components/auth/EmailInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76a07415"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76a07415', __exports__)) {
    api.reload('76a07415', __exports__)
  }
  
  module.hot.accept("./EmailInput.vue?vue&type=template&id=76a07415&scoped=true&ts=true", () => {
    api.rerender('76a07415', render)
  })

}


export default __exports__